// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3KZXs","requiredAsterisk":"Info_requiredAsterisk__1_tLv"};